import type MainProject from '@/model/MainProject'

let _project: MainProject | null = null

/** 供事件列表描述拼接读取工程数据（字符串表、气泡区、角色站位、自定义 UI 等） */
export function setEventDescriptionProject(p: MainProject | null): void {
  _project = p
}

export function getEventDescriptionProject(): MainProject | null {
  return _project
}
